import { Controller } from "@hotwired/stimulus"

// Opens a modal by ID from anywhere in the DOM
// Usage: <button data-controller="modal-opener" data-action="click->modal-opener#open" data-modal-opener-target-value="modal-id">
export default class extends Controller {
  static values = { target: String }

  open(event) {
    event.preventDefault()

    const modalId = this.targetValue
    const modalElement = document.getElementById(modalId)

    if (modalElement) {
      // Find the railsui-modal controller and trigger open
      const controller = this.application.getControllerForElementAndIdentifier(modalElement, 'railsui-modal')
      if (controller && typeof controller.open === 'function') {
        controller.open(event)
      }
    }
  }
}
